import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ManagerRegisterPage = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1); // 1~5 단계
  const [form, setForm] = useState({
    name: '', age: '', phone: '', gender: '',
    region: '', subRegion: '',
    vehicleType: '', vehicleOwnership: '', plateNo: '',
    bankName: '', bankAccount: '',
    experience: '', accidentFree: '',
    agreeTerms: false, agreePrivacy: false,
  });
  const [educationDone, setEducationDone] = useState(false);
  const [educationProgress, setEducationProgress] = useState(0);

  const seoulRegions = ['강남구', '강동구', '강북구', '강서구', '관악구', '광진구', '구로구', '금천구', '노원구', '도봉구', '동대문구', '동작구', '마포구', '서대문구', '서초구', '성동구', '성북구', '송파구', '양천구', '영등포구', '용산구', '은평구', '종로구', '중구', '중랑구'];

  const vehicleTypes = [
    { val: 'damas', label: '🚐 다마스 (소형)', cap: '300kg' },
    { val: '1ton', label: '🚚 1톤 트럭', cap: '1,000kg' },
    { val: '2.5ton', label: '🚛 2.5톤 트럭', cap: '2,500kg' },
    { val: '5ton', label: '🚜 5톤 트럭', cap: '5,000kg' },
    { val: 'rental', label: '🔑 렌탈 차량', cap: '종류 다양' },
  ];

  const update = (key, val) => setForm(prev => ({ ...prev, [key]: val }));

  const stepTitles = ['기본 정보', '지역 설정', '차량 등록', '계좌 & 경력', '교육 이수'];

  const startEducation = () => {
    let progress = 0;
    const interval = setInterval(() => {
      progress += 5;
      setEducationProgress(progress);
      if (progress >= 100) {
        clearInterval(interval);
        setEducationDone(true);
      }
    }, 150);
  };

  const canNext = () => {
    if (step === 1) return form.name && form.age && form.phone && form.gender;
    if (step === 2) return form.region;
    if (step === 3) return form.vehicleType && form.vehicleOwnership;
    if (step === 4) return form.bankName && form.bankAccount;
    if (step === 5) return educationDone && form.agreeTerms && form.agreePrivacy;
    return false;
  };

  const handleSubmit = () => {
    navigate('/manager-complete');
  };

  return (
    <div className="page-white">
      {/* 헤더 */}
      <div style={{ background: 'linear-gradient(135deg, #F39C12 0%, #E67E22 100%)', padding: '20px 20px 24px' }}>
        <button
          onClick={() => step > 1 ? setStep(step - 1) : navigate(-1)}
          style={{ background: 'rgba(255,255,255,0.2)', border: 'none', borderRadius: 10, padding: '8px 12px', color: 'white', cursor: 'pointer', marginBottom: 12 }}
        >← 뒤로</button>
        <div style={{ color: 'white', fontSize: 22, fontWeight: 800, marginBottom: 4 }}>
          🧑‍💼 영차매니저 등록
        </div>
        <div style={{ color: 'rgba(255,255,255,0.85)', fontSize: 13, marginBottom: 16 }}>
          내 지역에서 가구 배송하고 수익 창출!
        </div>

        {/* 단계 표시 */}
        <div style={{ display: 'flex', gap: 4 }}>
          {stepTitles.map((title, i) => (
            <div key={i} style={{ flex: 1, textAlign: 'center' }}>
              <div style={{
                height: 4, borderRadius: 2,
                background: i < step ? 'white' : 'rgba(255,255,255,0.3)',
                marginBottom: 4, transition: 'background 0.3s'
              }}/>
              <div style={{ fontSize: 9, color: i < step ? 'white' : 'rgba(255,255,255,0.5)', fontWeight: 600 }}>
                {title}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div style={{ padding: '24px 20px 100px' }}>
        <div style={{ background: '#FFF9E6', borderRadius: 12, padding: 14, marginBottom: 20, border: '1px solid #FFE0A0' }}>
          <div style={{ fontWeight: 700, fontSize: 14, color: '#B7791F' }}>
            📝 STEP {step}. {stepTitles[step-1]}
          </div>
        </div>

        {/* Step 1: 기본 정보 */}
        {step === 1 && (
          <div>
            <div className="input-group">
              <label className="input-label">이름</label>
              <input className="input-field" value={form.name} onChange={e => update('name', e.target.value)} placeholder="홍길동" />
            </div>
            <div className="input-group">
              <label className="input-label">나이 (20세 ~ 70세)</label>
              <select className="input-field" value={form.age} onChange={e => update('age', e.target.value)}>
                <option value="">나이 선택</option>
                {Array.from({ length: 51 }, (_, i) => i + 20).map(a => (
                  <option key={a} value={a}>{a}세</option>
                ))}
              </select>
            </div>
            <div className="input-group">
              <label className="input-label">연락처</label>
              <input className="input-field" value={form.phone} onChange={e => update('phone', e.target.value)} placeholder="010-0000-0000" />
            </div>
            <div className="input-group">
              <label className="input-label">성별</label>
              <div style={{ display: 'flex', gap: 8 }}>
                {['남성', '여성'].map(g => (
                  <button
                    key={g}
                    onClick={() => update('gender', g)}
                    style={{
                      flex: 1, padding: '14px', border: `2px solid ${form.gender === g ? '#F39C12' : '#E5E7EB'}`,
                      borderRadius: 12, background: form.gender === g ? '#FFF9E6' : 'white',
                      color: form.gender === g ? '#B7791F' : '#4B5563',
                      fontWeight: 700, cursor: 'pointer'
                    }}
                  >{g}</button>
                ))}
              </div>
            </div>

            {/* 수익 안내 */}
            <div style={{ background: '#F9FAFB', borderRadius: 14, padding: 16, marginTop: 8 }}>
              <div style={{ fontWeight: 700, fontSize: 14, color: '#1F2937', marginBottom: 8 }}>💰 예상 수익</div>
              {[
                { label: '알바 매니저 (월 20~30건)', val: '30~60만원' },
                { label: '전문 매니저 (월 50건 이상)', val: '80~120만원' },
                { label: '최우선 매니저 (연 100건+)', val: '채용 기회 제공' },
              ].map((item, i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #E5E7EB' }}>
                  <span style={{ fontSize: 13, color: '#6B7280' }}>{item.label}</span>
                  <span style={{ fontSize: 13, fontWeight: 700, color: '#F39C12' }}>{item.val}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Step 2: 지역 설정 */}
        {step === 2 && (
          <div>
            <div style={{ fontWeight: 700, fontSize: 15, color: '#1F2937', marginBottom: 8 }}>
              📍 담당 지역 선택
            </div>
            <div style={{ fontSize: 13, color: '#6B7280', marginBottom: 14, lineHeight: 1.6 }}>
              본인이 거주하는 지역 기반으로 배송이 가능합니다.<br/>
              총 10km 이내 또는 선택한 구청까지만 배송 가능합니다.
            </div>

            <div className="input-group">
              <label className="input-label">지역 (광역시/도)</label>
              <select className="input-field" value={form.region} onChange={e => update('region', e.target.value)}>
                <option value="">지역 선택</option>
                <option value="서울">서울특별시</option>
                <option value="경기">경기도</option>
                <option value="인천">인천광역시</option>
                <option value="부산">부산광역시</option>
                <option value="대구">대구광역시</option>
                <option value="광주">광주광역시</option>
                <option value="대전">대전광역시</option>
              </select>
            </div>

            {form.region === '서울' && (
              <div>
                <div style={{ fontWeight: 600, fontSize: 14, color: '#1F2937', marginBottom: 10 }}>🗺️ 담당 구 선택</div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 6 }}>
                  {seoulRegions.map(r => (
                    <button
                      key={r}
                      onClick={() => update('subRegion', r)}
                      style={{
                        padding: '10px 4px', border: `2px solid ${form.subRegion === r ? '#F39C12' : '#E5E7EB'}`,
                        borderRadius: 8, background: form.subRegion === r ? '#FFF9E6' : 'white',
                        color: form.subRegion === r ? '#B7791F' : '#4B5563',
                        fontWeight: form.subRegion === r ? 700 : 500, fontSize: 12, cursor: 'pointer'
                      }}
                    >{r}</button>
                  ))}
                </div>
              </div>
            )}

            <div style={{ background: '#e8f8ef', borderRadius: 12, padding: 14, marginTop: 16 }}>
              <div style={{ fontSize: 13, color: '#166534', lineHeight: 1.7 }}>
                ✅ 선택 지역 반경 10km 이내 배송<br/>
                ✅ 추가 지역 확장 신청 가능<br/>
                ✅ 우선순위 배정으로 수익 극대화
              </div>
            </div>
          </div>
        )}

        {/* Step 3: 차량 등록 */}
        {step === 3 && (
          <div>
            <div style={{ fontWeight: 700, fontSize: 15, color: '#1F2937', marginBottom: 12 }}>
              🚚 차량 유형 선택
            </div>
            {vehicleTypes.map(v => (
              <div
                key={v.val}
                onClick={() => update('vehicleType', v.val)}
                style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                  padding: '14px 16px', border: `2px solid ${form.vehicleType === v.val ? '#F39C12' : '#E5E7EB'}`,
                  borderRadius: 12, background: form.vehicleType === v.val ? '#FFF9E6' : 'white',
                  marginBottom: 8, cursor: 'pointer', transition: 'all 0.2s'
                }}
              >
                <div>
                  <div style={{ fontWeight: 700, fontSize: 14, color: '#1F2937' }}>{v.label}</div>
                  <div style={{ fontSize: 12, color: '#9CA3AF' }}>최대 적재 {v.cap}</div>
                </div>
                {form.vehicleType === v.val && <span style={{ color: '#F39C12', fontWeight: 700 }}>✓ 선택</span>}
              </div>
            ))}

            <div style={{ marginTop: 16 }}>
              <div style={{ fontWeight: 700, fontSize: 15, color: '#1F2937', marginBottom: 10 }}>🔑 차량 소유</div>
              <div style={{ display: 'flex', gap: 8 }}>
                {['본인 소유 차량', '렌탈 차량'].map(o => (
                  <button
                    key={o}
                    onClick={() => update('vehicleOwnership', o)}
                    style={{
                      flex: 1, padding: '14px', border: `2px solid ${form.vehicleOwnership === o ? '#F39C12' : '#E5E7EB'}`,
                      borderRadius: 12, background: form.vehicleOwnership === o ? '#FFF9E6' : 'white',
                      color: form.vehicleOwnership === o ? '#B7791F' : '#4B5563',
                      fontWeight: 700, fontSize: 13, cursor: 'pointer'
                    }}
                  >{o}</button>
                ))}
              </div>
            </div>

            {form.vehicleOwnership === '본인 소유 차량' && (
              <div className="input-group" style={{ marginTop: 16 }}>
                <label className="input-label">🔢 차량 번호판 (본인 소유 차량만)</label>
                <input
                  className="input-field"
                  value={form.plateNo}
                  onChange={e => update('plateNo', e.target.value)}
                  placeholder="예: 서울 12가 3456"
                />
              </div>
            )}

            <div style={{ background: '#FFF9E6', borderRadius: 12, padding: 14, marginTop: 8 }}>
              <div style={{ fontSize: 13, color: '#92400E', lineHeight: 1.7 }}>
                ⚠️ 차량 등록증 사본 제출 필요<br/>
                ⚠️ 본인 소유 차량에 한하여 등록 가능<br/>
                ⚠️ 렌탈 차량은 계약서 제출 필요
              </div>
            </div>
          </div>
        )}

        {/* Step 4: 계좌 & 경력 */}
        {step === 4 && (
          <div>
            <div className="input-group">
              <label className="input-label">🏦 은행 선택</label>
              <select className="input-field" value={form.bankName} onChange={e => update('bankName', e.target.value)}>
                <option value="">은행 선택</option>
                {['국민은행', '신한은행', '우리은행', '하나은행', 'IBK기업은행', '농협은행', '카카오뱅크', '토스뱅크'].map(b => (
                  <option key={b} value={b}>{b}</option>
                ))}
              </select>
            </div>

            <div className="input-group">
              <label className="input-label">💳 계좌번호</label>
              <input
                className="input-field"
                value={form.bankAccount}
                onChange={e => update('bankAccount', e.target.value)}
                placeholder="예금주 본인 계좌만 등록 가능"
              />
            </div>

            <div style={{ height: 1, background: '#E5E7EB', margin: '16px 0' }}/>

            <div className="input-group">
              <label className="input-label">📋 운반 경력</label>
              <select className="input-field" value={form.experience} onChange={e => update('experience', e.target.value)}>
                <option value="">경력 선택</option>
                <option value="none">없음 (처음 시작)</option>
                <option value="1">1년 미만</option>
                <option value="2">1~3년</option>
                <option value="3">3~5년</option>
                <option value="5">5년 이상</option>
              </select>
            </div>

            <div className="input-group">
              <label className="input-label">🚗 무사고 기간</label>
              <select className="input-field" value={form.accidentFree} onChange={e => update('accidentFree', e.target.value)}>
                <option value="">선택</option>
                <option value="1">1년 이상</option>
                <option value="3">3년 이상</option>
                <option value="5">5년 이상</option>
                <option value="10">10년 이상</option>
              </select>
            </div>

            {/* 등급 안내 */}
            <div style={{ background: '#F9FAFB', borderRadius: 14, padding: 16, marginTop: 8 }}>
              <div style={{ fontWeight: 700, fontSize: 14, color: '#1F2937', marginBottom: 10 }}>🏆 매니저 등급 기준</div>
              {[
                { grade: '🔵 일반 매니저', cond: '교육 이수 후 등록', reward: '기본 배분율' },
                { grade: '🟡 우수 매니저', cond: '연 50건 이상 완료', reward: '우선 배정 + 5% 추가' },
                { grade: '🔴 최우선 매니저', cond: '연 100건+ 무사고', reward: '채용 기회 제공' },
              ].map((item, i) => (
                <div key={i} style={{ padding: '10px 0', borderBottom: '1px solid #E5E7EB' }}>
                  <div style={{ fontWeight: 700, fontSize: 13, color: '#1F2937' }}>{item.grade}</div>
                  <div style={{ fontSize: 12, color: '#6B7280', marginTop: 2 }}>조건: {item.cond}</div>
                  <div style={{ fontSize: 12, color: '#F39C12', fontWeight: 600 }}>혜택: {item.reward}</div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Step 5: 온라인 교육 */}
        {step === 5 && (
          <div>
            <div style={{ background: 'white', borderRadius: 16, padding: 20, marginBottom: 16, border: '1px solid #E5E7EB' }}>
              <div style={{ fontWeight: 700, fontSize: 16, color: '#1F2937', marginBottom: 4 }}>
                🎓 영차매니저 온라인 교육
              </div>
              <div style={{ fontSize: 13, color: '#6B7280', marginBottom: 16 }}>
                매니저 등록 전 1일 온라인 교육 이수가 필요합니다
              </div>

              {[
                { time: '20분', title: '어디용차 서비스 소개', icon: '📱' },
                { time: '15분', title: '가구 취급 주의사항', icon: '🛋️' },
                { time: '10분', title: '안전 포장 방법', icon: '📦' },
                { time: '10분', title: '고객 응대 가이드', icon: '😊' },
                { time: '5분', title: '앱 사용 방법', icon: '📲' },
              ].map((c, i) => (
                <div key={i} style={{
                  display: 'flex', alignItems: 'center', gap: 12, padding: '12px 0',
                  borderBottom: '1px solid #E5E7EB', opacity: educationDone || educationProgress > (i * 20) ? 1 : 0.5
                }}>
                  <span style={{ fontSize: 22 }}>{c.icon}</span>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 600, fontSize: 14, color: '#1F2937' }}>{c.title}</div>
                    <div style={{ fontSize: 12, color: '#9CA3AF' }}>{c.time}</div>
                  </div>
                  {(educationDone || educationProgress > (i + 1) * 20) && (
                    <span style={{ color: '#27AE60', fontWeight: 700 }}>✓</span>
                  )}
                </div>
              ))}

              {educationProgress > 0 && (
                <div style={{ marginTop: 16 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
                    <span style={{ fontSize: 13, color: '#6B7280' }}>교육 진행률</span>
                    <span style={{ fontSize: 13, fontWeight: 700, color: '#F39C12' }}>{educationProgress}%</span>
                  </div>
                  <div className="progress-bar">
                    <div className="progress-fill" style={{ width: `${educationProgress}%`, background: '#F39C12' }}/>
                  </div>
                </div>
              )}

              {!educationDone ? (
                <button
                  onClick={startEducation}
                  disabled={educationProgress > 0 && educationProgress < 100}
                  style={{
                    width: '100%', marginTop: 16, padding: '14px',
                    background: educationProgress > 0 ? '#E5E7EB' : '#F39C12',
                    color: educationProgress > 0 ? '#9CA3AF' : 'white',
                    border: 'none', borderRadius: 12, fontWeight: 700, cursor: educationProgress > 0 ? 'not-allowed' : 'pointer'
                  }}
                >
                  {educationProgress > 0 ? '교육 진행 중...' : '🎓 교육 시작하기'}
                </button>
              ) : (
                <div style={{ marginTop: 16, background: '#e8f8ef', borderRadius: 10, padding: 12, textAlign: 'center' }}>
                  <span style={{ fontWeight: 700, color: '#27AE60' }}>✅ 교육 이수 완료!</span>
                </div>
              )}
            </div>

            {/* 동의 체크 */}
            <div style={{ background: '#F9FAFB', borderRadius: 14, padding: 16, marginBottom: 16 }}>
              {[
                { key: 'agreeTerms', label: '서비스 이용약관 동의 (필수)' },
                { key: 'agreePrivacy', label: '개인정보 수집 및 이용 동의 (필수)' },
              ].map(item => (
                <div
                  key={item.key}
                  onClick={() => update(item.key, !form[item.key])}
                  style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '12px 0', cursor: 'pointer', borderBottom: '1px solid #E5E7EB' }}
                >
                  <div style={{
                    width: 22, height: 22, borderRadius: 6, border: `2px solid ${form[item.key] ? '#F39C12' : '#D1D5DB'}`,
                    background: form[item.key] ? '#F39C12' : 'white',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0
                  }}>
                    {form[item.key] && <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>}
                  </div>
                  <span style={{ fontSize: 14, color: '#4B5563' }}>{item.label}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* 다음 버튼 */}
        {step < 5 ? (
          <button
            onClick={() => canNext() && setStep(step + 1)}
            disabled={!canNext()}
            style={{
              width: '100%', padding: '16px', borderRadius: 16,
              background: canNext() ? '#F39C12' : '#E5E7EB',
              color: canNext() ? 'white' : '#9CA3AF',
              border: 'none', fontWeight: 800, fontSize: 16,
              cursor: canNext() ? 'pointer' : 'not-allowed'
            }}
          >
            다음 단계 →
          </button>
        ) : (
          <button
            onClick={() => {
              if (canNext()) {
                setStep(99);
              }
            }}
            disabled={!canNext()}
            style={{
              width: '100%', padding: '16px', borderRadius: 16,
              background: canNext() ? '#27AE60' : '#E5E7EB',
              color: canNext() ? 'white' : '#9CA3AF',
              border: 'none', fontWeight: 800, fontSize: 16,
              cursor: canNext() ? 'pointer' : 'not-allowed',
              boxShadow: canNext() ? '0 4px 16px rgba(39,174,96,0.4)' : 'none'
            }}
          >
            🎉 영차매니저 등록 완료
          </button>
        )}

        {/* 등록 완료 화면 */}
        {step === 99 && (
          <div style={{
            position: 'fixed', inset: 0, background: 'white',
            display: 'flex', flexDirection: 'column', alignItems: 'center',
            justifyContent: 'center', padding: 40, textAlign: 'center', zIndex: 999
          }}>
            <div style={{ fontSize: 80, marginBottom: 20 }}>🎉</div>
            <div style={{ fontWeight: 800, fontSize: 26, color: '#1F2937', marginBottom: 8 }}>등록 완료!</div>
            <div style={{ fontSize: 15, color: '#6B7280', lineHeight: 1.7, marginBottom: 32 }}>
              <strong style={{ color: '#F39C12' }}>{form.name || '영차매니저'}</strong>님,<br/>
              어디용차 가족이 되신 것을 환영합니다! 🚐<br/>
              심사 완료 후 배정이 시작됩니다 (1~2 영업일)
            </div>
            <button
              onClick={() => navigate('/')}
              style={{
                background: '#FF6B35', color: 'white', border: 'none',
                borderRadius: 16, padding: '16px 40px', fontWeight: 800, fontSize: 16, cursor: 'pointer'
              }}
            >홈으로 가기</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ManagerRegisterPage;
